export function onDelegation(attr, actions) {
  return event => {
    const target = event.target.closest(`[${attr}]`);
    const action = target ? target.getAttribute(attr) : false;

    if (typeof actions?.[action] === 'function') {
      event.stopPropagation(); // para que se ejecute solo el primer eventDelegation
      actions[action](event, target);
    }
  };
}
